var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineVector4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1135,
    height: 900,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 900l377.118-506.651c7.965-10.701 23.975-10.753 32.009-.103l178.03 235.986c7.899 10.47 23.568 10.631 31.681.326L1133-21",
    stroke: "#EEE",
    strokeWidth: 3
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEzNSIgaGVpZ2h0PSI5MDAiIHZpZXdCb3g9IjAgMCAxMTM1IDkwMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgOTAwTDM3OS4xMTggMzkzLjM0OUMzODcuMDgzIDM4Mi42NDggNDAzLjA5MyAzODIuNTk2IDQxMS4xMjcgMzkzLjI0Nkw1ODkuMTU3IDYyOS4yMzJDNTk3LjA1NiA2MzkuNzAyIDYxMi43MjUgNjM5Ljg2MyA2MjAuODM4IDYyOS41NThMMTEzMyAtMjEiIHN0cm9rZT0iI0VFRUVFRSIgc3Ryb2tlLXdpZHRoPSIzIi8+Cjwvc3ZnPgo=";
export { SvgLineVector4 as ReactComponent };